import { baseApi } from './baseApi';

export interface SlideEntry {
  bucket: string;
  key: string;
  assetId: string;
}

export interface PptxBuildSpecification {
  slides: SlideEntry[];
}

export const pptxBuildService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    buildPresentation: builder.mutation<Blob, PptxBuildSpecification>({
      query: (buildSpec) => ({
        url: 'http://localhost:7070/build',
        method: 'POST',
        body: buildSpec,
        responseHandler: async (response) => {
          return await response.blob();
        },
      }),
    }),
  }),
});

export const { useBuildPresentationMutation } = pptxBuildService;
